import type { EBaseSetupGuideCampaign } from '~/modules/campaign/types';

export enum ESetupGuideCampaignUrlRedirect {
  SET_CONTROL_URL = 'SET_CONTROL_URL',
  SET_VARIANT_URL = 'SET_VARIANT_URL',
}

export type ISetupGuideCampaignUrlRedirect =
  | ESetupGuideCampaignUrlRedirect
  | EBaseSetupGuideCampaign;

export type IGSetupGuideUrlRedirectStatuses = Partial<
  Record<ISetupGuideCampaignUrlRedirect, boolean>
>;
